<template>
<div class="content has-text-centered">

  <div class="columns is-vcentered">
    <div class="column is-6 is-offset-3">
      <div class="box">
        <form v-on:submit.prevent="login">
          <label class="label">Email</label>
          <p class="control">
            <input v-model="data.body.username" class="input" type="text" placeholder="email@example.org">
          </p>
          <label class="label">Password</label>
          <p class="control">
            <input v-model="data.body.password" class="input" type="password" placeholder="password">
          </p>

          <!--<p class="control">-->
            <!--<label class="checkbox">-->
              <!--<input type="checkbox" v-model="data.rememberMe">-->
              <!--Remember me-->
            <!--</label>-->
          <!--</p>-->

          <hr>
          <p class="control">
            <button type="submit" class="button is-primary">Войти</button>
            <a v-if="canSignUp" href="#/sign-up" class="button is-success">
              <span>Зарегистрироваться</span>
            </a>
          </p>
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import { mapActions } from 'vuex'
  import Vue from 'vue'
  import Notification from 'vue-bulma-notification'

  const AUTH_API = '/api/auth'
  const APPCONFIG_API = '/api/appConfig'

  const NotificationComponent = Vue.extend(Notification)
  const openNotification = (propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  }) => {
    return new NotificationComponent({
      el: document.createElement('div'),
      propsData
    })
  }

export default {
  components: {
    Notification
  },

  data() {
    return {
      data: {
        body: {
          username: null,
          password: null
        },
        rememberMe: false
      },
      canSignUp: true
    }
  },
  created: function () {
    this.loadAppConfig()
  },
  mounted() {
    // if (this.$auth.redirect()) {
    //   console.log('Redirect from: ' + this.$auth.redirect().from.name)
    // }
    // Can set query parameter here for auth redirect or just do it silently in login redirect.
  },
  methods: {
    ...mapActions([
      'setAuthenticationToken',
      'setLoggedRole',
      'setLoggedStatus',
      'setLoggedId',
      'setLoggedUser',
      'setLoggedUserState',
      'setPermissionMap',
      'setClientId'
    ]),
      login() {
        this.$http.post(AUTH_API + '/sign-in', this.data.body)
          .then((response) => {
            this.setAuthenticationToken(response.data.auth.token)
            this.setLoggedRole(response.data.role)
            this.setLoggedId(response.data.id)
            this.setLoggedUser(response.data.username)
            this.setLoggedUserState(response.data.state)
            this.setLoggedStatus(true)
            this.setPermission(response.data.role)
            this.setClientId(response.data.clientid)
            this.openNotificationWithType('success', 'Осуществлен вход ' + this.data.body.username)
            this.$router.push('/campaigns')
          })
          .catch((error) => {
            this.openNotificationWithType('danger', 'Ошибка авторизации')
            console.log(error)
          })
      },
    setPermission(role) {
      this.$http.get(AUTH_API + '/getPermissions/' + role, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          var pMap = JSON.stringify(Object.entries(response.data))
          this.setPermissionMap(pMap)
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка установки разрешений. ')
        })
    },
    loadAppConfig () {
      this.$http.get(APPCONFIG_API, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.appconfig = response.data
          this.canSignUp = this.appconfig.userCanSignUp
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ')
        })
    },
    openNotificationWithType (type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      })
    }

    // login() {
    //   // var redirect = this.$auth.redirect()
    //   // console.log(redirect)
    //   this.$auth.login({
    //     headers: {
    //       'Content-Type': 'application/json'
    //     },
    //     data: this.data.body,
    //     rememberMe: this.data.rememberMe,
    //     // redirect: {name: redirect ? redirect.from.name : 'Заявки'},
    //     success(res) {
    //       console.log('Auth Success')
    //       console.log('Token: ' + this.$auth.token())
    //       console.log(res)
    //     },
    //     error(err) {
    //       if (err.response) {
    //         // The request was made, but the server responded with a status code
    //         // that falls out of the range of 2xx
    //         // console.log(err.response.status)
    //         // console.log(err.response.data)
    //         // console.log(err.response.headers)
    //         this.error = err.response.data
    //       } else {
    //         // Something happened in setting up the request that triggered an Error
    //         console.log('Error', err.message)
    //       }
    //       console.log(err.config)
    //     }
    //   })
    // }
  }
}
  // }
  // filters: {
  //   json: function (value) {
  //     console.log(value)
  //     return value
  //   }
  // }
</script>

<style lang="scss" scoped>
.is-title {
    text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// Login.vue?ee6feb3e